import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import TimetableToolbar from '../timetableToolbar/TimetableToolbar';
import FilterIcon from '../../../../assets/icons/FilterIcon';
import Search from '../../../../assets/icons/search';
import * as css from './TimetableHeader.css';

type Props = {
    conferenceDatesAction: {label: string; onClick: () => void; icon?: ReactNode};
    searchQuery: string;
    onSearchChange: (value: string) => void;
};

const TimetableHeader = ({conferenceDatesAction, searchQuery, onSearchChange}: Props) => {
    const {t} = useTranslation('timetable');

    return (
        <css.wrap>
            <css.contentArea>
                <css.toolbarRow>
                    <TimetableToolbar />
                    <Button
                        variant="neutral"
                        size="category"
                        onClick={conferenceDatesAction.onClick}
                    >
                        {conferenceDatesAction.label}
                    </Button>
                </css.toolbarRow>
                <css.filterRow>
                    <css.filterCard>
                        <Button
                            variant="neutral"
                            size="category"
                            iconStart={<FilterIcon width={20} height={20} />}
                            disabled
                        >
                            {t('filter')}
                        </Button>
                        <css.searchPill data-cy="timetableSearch">
                            <css.searchInput
                                type="text"
                                value={searchQuery}
                                onChange={e => onSearchChange(e.target.value)}
                                placeholder={t('search')}
                                aria-label={t('search')}
                            />
                            <Search />
                        </css.searchPill>
                    </css.filterCard>
                </css.filterRow>
            </css.contentArea>
        </css.wrap>
    );
};

export default TimetableHeader;
